import React, { useState } from "react";
import { Nav, Badge } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import {
  FaTachometerAlt,
  FaBroom,
  FaCalendarAlt,
  FaUsers,
  FaChartLine,
  FaCog,
  FaBell,
  FaQuestionCircle,
  FaSignOutAlt,
  FaChevronRight,
  FaHome,
  FaBuilding,
} from "react-icons/fa";
import { MdOutlineCleaningServices, MdOutlinePolicy } from "react-icons/md";
import { RiCouponLine } from "react-icons/ri";
import styles from "./css/Sidebar.module.css";

const Sidebar = () => {
  const location = useLocation();
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  return (
    <div className={styles.sidebar}>
      <h4 className={styles.title}>House Care</h4>
      <Nav className="flex-column">
        {/* Dashboard */}
        <Nav.Link
          as={Link}
          to="/dashboard"
          className={`${styles.link} ${
            location.pathname === "/dashboard" ? styles.active : ""
          }`}
        >
          <FaTachometerAlt /> <span className={styles.label}>Dashboard</span>
        </Nav.Link>

        {/* Services Dropdown */}
        <div className={styles.link} onClick={() => toggleDropdown("services")}>
          <MdOutlineCleaningServices />
          <span className={styles.label}>Cleaning Services</span>
          <FaChevronRight
            className={`${styles.arrow} ${
              openDropdown === "services" ? styles.arrowOpen : ""
            }`}
          />
        </div>
        <div
          className={`${styles.dropdown} ${
            openDropdown === "services" ? styles.showDropdown : ""
          }`}
        >
          <Link to="/dashboard/mainCategory" className={styles.dropdownLink}>
            Main Category
          </Link>
          <Link to="/dashboard/mainParentCategory" className={styles.dropdownLink}>
            Parent Category
          </Link>
          <Link to="/dashboard/mainChildCategory" className={styles.dropdownLink}>
            Child Category
          </Link>
          <Link to="/dashboard/custom-service" className={styles.dropdownLink}>
            Custom Service
          </Link>
        </div>

        {/* Bookings */}
        <Nav.Link
          as={Link}
          to="/dashboard/bookings"
          className={`${styles.link} ${
            location.pathname === "/dashboard/bookings" ? styles.active : ""
          }`}
        >
          <FaCalendarAlt /> <span className={styles.label}>Bookings</span>
        </Nav.Link>

        {/* Coupons */}
        <Nav.Link
          as={Link}
          to="/dashboard/coupons"
          className={`${styles.link} ${
            location.pathname === "/dashboard/coupons" ? styles.active : ""
          }`}
        >
          <RiCouponLine /> <span className={styles.label}>Promotions</span>
        </Nav.Link>

        {/* Staff Management */}
        <Nav.Link
          as={Link}
          to="/dashboard/staff"
          className={`${styles.link} ${
            location.pathname === "/dashboard/staff" ? styles.active : ""
          }`}
        >
          <FaUsers /> <span className={styles.label}>Staff Management</span>
        </Nav.Link>

        {/* Policies */}
        <Nav.Link
          as={Link}
          to="/dashboard/policies"
          className={`${styles.link} ${
            location.pathname === "/dashboard/policies" ? styles.active : ""
          }`}
        >
          <MdOutlinePolicy /> <span className={styles.label}>Policies</span>
        </Nav.Link>

        {/* Reports */}
        <Nav.Link
          as={Link}
          to="/dashboard/reports"
          className={`${styles.link} ${
            location.pathname === "/dashboard/reports" ? styles.active : ""
          }`}
        >
          <FaChartLine /> <span className={styles.label}>Reports</span>
        </Nav.Link>

        {/* Settings */}
        <Nav.Link
          as={Link}
          to="/dashboard/settings"
          className={`${styles.link} ${
            location.pathname === "/dashboard/settings" ? styles.active : ""
          }`}
        >
          <FaCog /> <span className={styles.label}>Settings</span>
        </Nav.Link>

        {/* Notifications */}
        <Nav.Link
          as={Link}
          to="/dashboard/notifications"
          className={`${styles.link} ${
            location.pathname === "/dashboard/notifications"
              ? styles.active
              : ""
          }`}
        >
          <FaBell /> <span className={styles.label}>Notifications</span>
          <Badge bg="danger" pill className={styles.badge}>
            5
          </Badge>
        </Nav.Link>

        {/* Help */}
        <Nav.Link
          as={Link}
          to="/dashboard/help"
          className={`${styles.link} ${
            location.pathname === "/dashboard/help" ? styles.active : ""
          }`}
        >
          <FaQuestionCircle /> <span className={styles.label}>Help & Support</span>
        </Nav.Link>

        {/* Logout */}
        <Nav.Link as={Link} to="/logout" className={styles.link}>
          <FaSignOutAlt /> <span className={styles.label}>Logout</span>
        </Nav.Link>
      </Nav>
    </div>
  );
};

export default Sidebar;
